import React, { useContext, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import Location from 'components/sales/formSection/location/location';
import LeadDetails from 'components/sales/formSection/leadDetails/leadDetails';
import PocDetails from 'components/sales/formSection/pocDetails/pocDetails';
import CategoryDetails from 'components/sales/formSection/categoryDetails/categoryDetailsCorp';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import GatesForm from "components/sales/formSection/gates/addgateCorpCreateLead";
import Notfound from 'pages/notfound';

const EditCorporate = ({
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  locationState,
  editCorporateLeadSubmit,
  locationPinCode,
  pincodeData,
  supplyNameFun,
  splNameData,
  rwaTenureFun,
  rwaTenureData,
  getCorporateDropDown,
  corDropDownData,
  getCurrentLocation,
  latlng,
  toastMsg,
  getDetails,
  match,
  viewDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [corporateLeadData, setCorporateLeadData] = useState(null);
  const [corporatePocDetails, setCorporatePocDetails] = useState(null);
  const [corporateLocation, setCorporateLocation] = useState(null);
  const [corporateCategoryDetails, setCorporateCategoryDetails] = useState(
    null
  );
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [gateDetails, setGateDetails] = useState(null);

  useEffect(() => {
    if (match?.params?.id !== undefined && match?.params?.id !== null) {
      (async () => {
        const leadTypeId =
          (await JSON.parse(localStorage.getItem('viewDetail'))) &&
          JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type_id;
        const requestData = {
          lead_id: match.params.id,
          lead_type: leadTypeId,
        };
        if (requestData) {
          const res = await getDetails(requestData);
          if (res === null || res === '') {
            setIsRender(true);
          }
        }
      })();
    }
  }, [getDetails]);

  const handleLeadSubmit = (val) => {
    setCorporateLeadData(val);
  };
  const handlePocSubmit = (val) => setCorporatePocDetails(val);
  const handleLocSubmit = (val) => setCorporateLocation(val);
  const handleCatSubmit = (val) => {
    setCorporateCategoryDetails(val);
  };
  const handleGatesSubmit = (val) => setGateDetails(val);

  const handleModalHide = () => setIsModal(false);

  const handleSubmit = (leadId) => {
    const editCorporate = {
      ...corporateLeadData,
      ...corporatePocDetails,
      ...corporateLocation,
      ...corporateCategoryDetails,
      ...gateDetails,
    };
    if (
      corporateLeadData === null ||
      corporatePocDetails === null ||
      corporateLocation === null ||
      corporateCategoryDetails === null
    ) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      // console.log(editCorporate); return false;
      (async () => {
        const res = await editCorporateLeadSubmit({
          ...editCorporate,
          leadId: leadId,
        });
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getCorporateDropDown();
      setTimeout(() => setIsLoading(false), 500);
    })();
  }, [getCorporateDropDown]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => handleSubmit(match?.params?.id)}
          className="btn btn-primary"
        >
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
// console.log(handleLeadSubmit);
  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.editLeadCorporate}
      className={isFiled ? 'requiredFileds' : ''}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
    >
      <LeadDetails
        inputLabel={localization.clientName}
        isCorporate={true}
        corDropDownData={corDropDownData}
        handleValue={handleLeadSubmit}
        prefilledData={viewDetails}
      />
      <PocDetails
        corDropDownData={corDropDownData}
        handleValue={handlePocSubmit}
        prefilledData={viewDetails}
      />
      <Location
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        prefilledData={viewDetails}
      />
      <CategoryDetails
        isSupply={false}
        handleValue={handleCatSubmit}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
        rwaTenureFun={rwaTenureFun}
        rwaTenureData={rwaTenureData}
        corDropDownData={corDropDownData}
        prefilledData={viewDetails}
      />
      {/* <GatesForm
        gateType={rwaTenureData.gateType}
        handleValue={handleGatesSubmit}
        prefilledData={viewDetails}
      /> */}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.updateLeadSuccess}</h5>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-transparent"
          >
            {localization.updateLead}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
    </Layout>
  );
};

EditCorporate.propTypes = {
  LeadSource: PropTypes.func,
  sourceData: PropTypes.array,
  pocType: PropTypes.func,
  pocTypeData: PropTypes.array,
  leadCategories: PropTypes.func,
  leadCategory: PropTypes.array,
  locationCity: PropTypes.func,
  cities: PropTypes.array,
  locationZone: PropTypes.func,
  zones: PropTypes.array,
  locationArea: PropTypes.func,
  areas: PropTypes.array,
  locationType: PropTypes.func,
  locTypesData: PropTypes.any,
  locationState: PropTypes.func,
};

export default EditCorporate;
